import React from 'react';

export default function Footer() {
  return (
    <footer id="contact" className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <span className="logo-icon">☕</span>
          <span className="logo-text">CoffeeIL</span>
          <p className="footer-tagline">הטעם של האלפים, אצלך בבית</p>
        </div>
        <div className="footer-links">
          <a href="#story">הסיפור שלנו</a>
          <a href="#products">המוצרים</a>
          <a href="mailto:illyayu@coffeeil.co.il">illyayu@coffeeil.co.il</a>
        </div>
        <p className="footer-seo">
          CoffeeIL – פולי קפה איכותיים 100% ערביקה, קלייה איטית מסורתית, משלוח
          לכל הארץ. יבואנית פולי קפה צ׳יבו (Tchibo) לישראל. אם חיפשתם פולי קפה
          ערביקה, קפה איכותי, טציבו, טצ׳יבו, ציבו או צ׳יבו – הגעתם למקום הנכון.
          פולי קפה טריים ישירות מהאלפים אליכם הביתה.
        </p>
        <p className="footer-disclaimer">
          CoffeeIL היא יבואנית עצמאית של מוצרי צ'יבו. האתר אינו מופעל על ידי
          חברת Tchibo GmbH ואינו נציג רשמי שלה בישראל.
        </p>
        <p className="footer-copy">
          © {new Date().getFullYear()} CoffeeIL. כל הזכויות שמורות.
        </p>
      </div>
    </footer>
  );
}
